import type {
  MaterializedMenuProduct,
  StoreSpecial as V3StoreSpecial,
} from '@iheartjane/data-access';
import type { PriceId } from '@iheartjane/types';

import type { AlgoliaProduct } from '@jane/search/data-access';
import type { StoreSpecial } from '@jane/shared/types';

export const getApplicableSpecialForProductPriceId = (
  product: AlgoliaProduct | MaterializedMenuProduct,
  specials: (StoreSpecial | V3StoreSpecial)[] = [],
  weight: PriceId,
  supportedStoreSpecialIds: number[]
) => {
  if (!specials.length) return undefined;

  return specials.find((special) => {
    if (!supportedStoreSpecialIds.includes(special.id)) return false;

    if (special.special_type !== 'product') return false;

    const specialForPriceId = product[`special_price_${weight}`];

    if (!specialForPriceId) return false;

    return special.id === specialForPriceId.special_id;
  });
};
